export default __webpack_public_path__ + "static/cicaplast-d8404f5ece22d8a4b4d9d3288351303d.webm";